import {useEffect} from 'react';
import {isOutsideStaffHours} from '@functions/const/defaultWidgetSetting';

/** @type {string} */
const shopId = window.AVADA_APP_FAQS_STATUS?.shopId;
const isNotScripttag = process.env.BUILD_TARGET !== 'scripttag';

/**
 * Hook to handle staff status monitoring for both scripttag and admin environments
 * @param {Object} params Hook parameters
 * @param {string} params.optionOnline The option online staff
 * @param {Function} params.setIsStaffOnline A function to set the staff online status
 */
export default function useSetStaffStatusScripttag({optionOnline, setIsStaffOnline}) {
  useEffect(() => {
    if (isNotScripttag) return;
    if (isOutsideStaffHours(optionOnline)) return;

    let unsubscribe = null;
    const setupStaffMonitoring = async () => {
      try {
        const {doc, onSnapshot} = await import('firebase/firestore');
        const {db} = await import('@scripttag/helpers/firebaseHelpers');

        unsubscribe = onSnapshot(
          doc(db, 'realtimeStaffStatus', shopId),
          snapshot => {
            const {isOnline = {}} = snapshot.data() || {};
            const hasStaffOnline = Object.values(isOnline).some(
              item => (typeof item === 'boolean' && !!item) || (item.status && !item.enableAwayMode)
            );
            setIsStaffOnline(hasStaffOnline);
          },
          error => console.error(error)
        );
      } catch (error) {
        console.error('Failed to setup staff monitoring:', error);
      }
    };
    setupStaffMonitoring().then();

    return () => unsubscribe && unsubscribe();
  }, [optionOnline]);
}
